import React from 'react'
import PropTypes from 'prop-types'

// TODO: Figure out how to style posts without introducing XSS vectors
// import marked from 'marked'
// const renderMarkdown = (markdown) => {
//   return marked(markdown)
// }
// <div dangerouslySetInnerHTML={{ __html: marked.parse(post.entry, {sanitize: true}) }} />

const Entry = ({post}) => {
  // TODO: Get attachments working again:
  // let attachment = post.attachment;
  return (
    <div className="blog_entry" >
      <span className="title">{post.title}</span>
      <span className="author">Author: {post.user.name}</span>
      <span className="date">{post.created_at}</span><br/>
      <div style={{ "whiteSpace": "pre-wrap" }}>
        {post.entry}
      </div>

      {/*<div class="gallery post{post.id}">*/}
        {/*<a href={attachment.file.url} class="post_gallery_item" rel="post_gallery_item" title={attachment.description}*/}
           {/*ng-repeat="attachment in post.attachments">*/}

          {/*<img class="post_image" src={attachment.file.thumb.url} />*/}
        {/*</a>*/}
        {/*/!*<div>*!/*/}
        {/*%= link_to image_tag(attachment.file_url(:thumb), :class => "post_image"),*/}
        {/*attachment.file_url,*/}
        {/*:class => "post_gallery_item",*/}
        {/*:rel => "post_gallery_item",*/}
        {/*:title => attachment.description*/}
        {/*%*/}
        {/*/!*</div>*!/*/}
      {/*</div>*/}

      {/*<p>*/}
        {/*%= link_to "home", :action => "index" %>*/}
        {/*% if current_user.try(:admin?) %>*/}
        {/*%= link_to "edit", :action => "edit" %>*/}
        {/*% end %>*/}
      {/*</p>*/}
    </div>
  )
};

Entry.protoTypes = {
  post: PropTypes.object //.isRequired
};

export default Entry

// Don't need this method but maybe later:
// class Entry extends Component {
//
//   constructor(props) {
//     super(props)
//   }
//
//   render() {
//     return (
//       <div>
//         Entry goes here
//       </div>
//     )
//
//   }
// }



// WEBPACK FOOTER //
// ./src/components/Blog/Entry/index.js